import { api } from './../../api.js';
import { config } from './../../config.js';

const actions = {
    BACK_SIMPATIZANTES_ALTA : function({ commit },data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.simpatizantes.alta'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_SIMPATIZANTES_VALIDAR : function({ commit },data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.simpatizantes.validar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_SIMPATIZANTES_EDITAR : function({ commit },data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.simpatizantes.editar'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_SIMPATIZANTES_CREAR : function({ commit },data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.simpatizantes.crear'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_SIMPATIZANTES_INDEX : function({ commit },data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.simpatizantes.index'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    },
    BACK_SIMPATIZANTES_SHOW : function({ commit }, data){
        return new Promise((resolve, reject) => {
            api.call(config.getAPIRoute('back.simpatizantes.show'), data).then(res => {
                resolve(res);
            }).catch(error => {
                console.log(error);
                reject(error);
            });
        });
    }
}

export default {
    actions
};
